package app

import app.credit.statusValues
import app.properties.*
import app.settings.backendPath
import kotlinx.html.InputType
import kotlinx.html.id
import kotlinx.html.js.onBlurFunction
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.get
import react.*
import react.dom.*
import kotlin.browser.localStorage
import kotlin.browser.window
import kotlin.js.Date

interface CreditState : RState {
    var credit: Credit
    var time: Date
    var touch: Boolean
}

interface CreditFormProps : RProps {
    var credit : Credit?
    var requestEvent : dynamic
}

class CreditForm(props: CreditFormProps) : RComponent<CreditFormProps, CreditState>(props) {

    var creditTypeList : Array<CreditType>? = arrayOf()
    var currencyList : Array<Currency>? = arrayOf()
    var regionList : Array<Region>? = arrayOf()
    var guarantyList : Array<Guaranty>? = arrayOf()
    var companyType : Array<CompanyType>? = arrayOf()
    var familyType : Array<FamilyType>? = arrayOf()
    var educationType : Array<EducationType>? = arrayOf()
    var documentType : Array<DocumentType>? = arrayOf()

    var company = Company()
    var person = Person()

    var isProcessing = false


    init {
        state.credit = props.credit ?: Credit()

        if (props.credit?.company != null) {
            company = props.credit?.company!!
        }
        if (props.credit?.person != null) {
            person = props.credit?.person!!
        }

        axiosGet(backendPath + "/getParameters").then {

            creditTypeList = it.data.creditType
            currencyList = it.data.currency
            regionList = it.data.region
            guarantyList = it.data.guaranty
            companyType = it.data.companyType
            familyType = it.data.familyType
            educationType = it.data.educationType
            documentType = it.data.documentType

            setState {
                touch = false
            }

        }
    }

    override fun componentDidUpdate(prevProps: CreditFormProps, prevState: CreditState, snapshot: Any) {
        phoneMask { phone, index ->
            setState {
                credit.phones[index] = phone
            }
        }
    }

    override fun RBuilder.render() {

        fun sendCreditRequest(credit : Credit) {
            if (credit.isValid()) {
                credit.phones = credit.phones.filter { credit.telRegex.containsMatchIn(it) }.toMutableList()
                axiosPost(backendPath + "/credit/create", credit).then {
                    isProcessing = false
                    setState {
                        this.credit = Credit()
                        touch = false
                    }
                    if(it.data.status == 200) {
                        js("""new PNotify({
                                    text: 'Ձեր հայտը ընդունված է',
                                    type: 'success',
                                    styling: 'bootstrap3'
                                });""")
                    } else {
                        localStorage.removeItem("jwt")
                        setTimeOut(5000) {
                            window.location.assign("/admin")
                        }
                        js("""new PNotify({
                                    text: 'Տեղի է ունեցել սխալ խնդրում ենք կապնվել կայքի ադմինիստրացիայի հետ',
                                    type: 'error',
                                    styling: 'bootstrap3'
                                });""")
                    }

                    if(props.requestEvent != null) {
                        props.requestEvent(false)
                    }

                }
            } else {
                isProcessing = false
                setState {
                    touch = true
                }
                js("""new PNotify({
                                    text: 'Խնդրում ենք լրացնել բոլոր պարտադիր դաշտերը',
                                    type: 'error',
                                    styling: 'bootstrap3'
                                });""")
            }
        }

        if(window.location.pathname == "/") {

            div("container-fluid") {
                attrs {
                    jsStyle {
                        padding = "20px 0px"
                        boxShadow = "1px 1px 9px 0px #ccc"
                        marginBottom = "20px"
                    }
                }
                div("container") {
                    div("row") {
                        div("col-5") {
                            img(src = "images/logo.png") {
                                attrs {
                                    width = "100%"
                                }
                            }
                        }
                        div("col") {
                            ul("nav justify-content-end creditMenu") {
                                li("nav-item") {
                                    a(classes = "nav-link", target = "_blank", href = "http://agrocredit.am/hy/about-us/") {
                                        +"Մեր մասին"
                                    }
                                }
                                li("nav-item") {
                                    a(classes = "nav-link", target = "_blank", href = "http://agrocredit.am/hy/consumer-rights/") {
                                        +"Հաճախորդի իրավունքներ"
                                    }
                                }
                                li("nav-item") {
                                    a(classes = "nav-link", target = "_blank", href = "http://agrocredit.am/hy/contact-us/") {
                                        +"Կապ"
                                    }
                                }
                            }
                        }
                    }
                }
            }
            div("container-fluid") {
                attrs {
                    jsStyle {
                        background = "url(images/588dc4780f4ab52284f69ddb.jpg)"
                        height = "250px"
                        padding="0"
                        marginBottom = "20px"
                        backgroundPosition = "center"
                        position="relative"
                    }
                }
                div {
                    attrs {
                        jsStyle {
                            width="100%"
                            height="100%"
                            background="#000"
                            opacity="0.3"
                            position="absolute"
                        }
                    }
                }
                div("container") {
                    attrs {
                        jsStyle {
                            position="relative"
                        }
                    }
                    div {
                        attrs {
                            jsStyle {
                                paddingTop="80px"
                                fontSize="33px"
                                color="#fff"
                                fontWeight="600"
                                fontStyle="italic"
                            }
                        }
                        +"ԱՌՑԱՆՑ ԴԻՄՈՒՄ"
                    }
                }
            }
        }
        div("container") {
            div("row") {
                div("col-lg") {
                    label { +"Վարկի տեսակը" }
                    select("form-control") {

                        attrs["value"] = creditTypeList?.indexOfFirst { it.id == state.credit.creditType?.id }.toString()
                        attrs {
                            if(state.credit.creditType == null && state.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }

                        attrs.onChangeFunction = {
                            val index = getTargetValueToInt(it)
                            if (index == 0) {
                                state.credit.company = company
                                state.credit.person = null
                            } else if(index == 1) {
                                state.credit.company = null
                                state.credit.person = person
                            }
                            val creditType = if (index == null)  null  else creditTypeList?.get(index)
                            setState {
                                state.credit.creditType = creditType
                            }
                        }
                        option {
                            +"Ընտրել վարկի տեսակը"
                        }
                        creditTypeList?.forEachIndexed { index, creditType ->
                            option {
                                attrs.value = index.toString()
                                +creditType.name
                            }
                        }
                    }
                }
                div("col-lg") {
                    label { +"Արժույթ" }
                    select("form-control") {

                        attrs["value"] = currencyList?.indexOfFirst { it.id == state.credit.currency?.id }.toString()
                        attrs {
                            if(state.credit.currency == null && state.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }

                        attrs.onChangeFunction = {
                            val index = getTargetValueToInt(it)
                            val currenty = if (index == null)  null  else currencyList?.get(index)
                            setState {
                                state.credit.currency = currenty
                            }
                        }
                        option { +"Ընտրել արժույթը" }
                        currencyList?.forEachIndexed { index, currency ->
                            if(!(state.credit.creditType?.id == creditTypeList?.get(0)?.id && currency.id == currencyList?.get(1)?.id)) {
                                option {
                                    attrs.value = index.toString()
                                    +currency.name
                                }
                            }
                        }
                    }
                }
            }
            div("row") {
                div("col-lg") {
                    label { +"Վարկի գումարը" }
                    input(classes = "form-control", type = InputType.number) {
                        attrs {
                            if(state.credit.loanAmount <= 0 && state.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }
                        attrs["value"] = if (state.credit.loanAmount <= 0) "" else state.credit.loanAmount.toString()
                        attrs.onChangeFunction = {
                            val loanAmount = try {
                                getTargetValue(it).toFloat()
                            } catch (e: NumberFormatException) {
                                0F
                            }
                            setState {
                                credit.loanAmount = loanAmount
                            }
                        }
                    }
                }
                div("col-lg") {
                    label { +"Ժամկետ(ամիս)" }
                    select("form-control") {

                        attrs["value"] = state.credit.loanTime.toString()
                        attrs {
                            if(state.credit.loanTime == 0 && state.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }

                        attrs.name = "loanTime"
                        attrs.onChangeFunction = {
                            val loanTime = getTargetValueToInt(it)
                            setState {
                                credit.loanTime = loanTime ?: 12
                            }
                        }
                        (3..84).forEach {
                            option { +"$it" }
                        }
                    }
                }

                div("col-lg") {
                    label { +"Տոկոսադրույքը" }
                    select(classes = "form-control") {
                        attrs["value"] = state.credit.percent.toString()
                        attrs.onChangeFunction = {
                            val percent = try {
                                getTargetValue(it).toFloat()
                            } catch (e: NumberFormatException) {
                                12F
                            }
                            setState {
                                credit.percent = percent
                            }
                        }

                        (2..24).forEach {
                            option { +"$it" }
                        }
                    }
                }

                div("col-lg col-md-12") {
                    label { +"Ամսական մարում" }
                    input(classes = "form-control") {
                        attrs.disabled = true
                        attrs["value"] = state.credit.calculatePaymentPerMonth()
                    }
                    small { +"Հնարավոր է պարբերական (ճկուն) գրաֆիկ" }
                }
            }
            div("row") {
                label("col") {
                    +"Վարկի ապահովություն"
                }
            }
            div("row") {
                guarantyList?.forEach {
                    div("col-lg col-md-12") {
                        val guarantyId = "guarantyCheckbox${it.id}"
                        input(InputType.checkBox) {
                            attrs {
                                id = guarantyId
                                value = it.name
                                this["checked"] = state.credit.guaranty.contains(it.name)
                                jsStyle {
                                    margin = "0px 10px"
                                }
                                onChangeFunction = { event ->
                                    val valueOfChecbox = getTargetValue(event)

                                    if(valueOfChecbox.toBoolean()) {
                                        setState {
                                            credit.guaranty.add(it.name)
                                        }
                                    } else {
                                        setState {
                                            credit.guaranty.remove(it.name)
                                        }
                                    }

                                }
                            }
                        }
                        label {
                            attrs {
                                this["htmlFor"] = guarantyId
                                jsStyle {
                                    cursor = "pointer"
                                    if (state.credit.guaranty.size == 0 && state.touch) {
                                       color = "red"
                                    }
                                }
                            }
                            +it.name
                        }
                    }
                }
            }
            if(state.credit.creditType?.id == creditTypeList?.get(0)?.id) {
                companyForm(state.credit.company, companyType, state.touch)
            }
            if(state.credit.creditType?.id == creditTypeList?.get(1)?.id) {
                personInfoForm(state.credit.person, familyType, educationType, regionList, state.touch)
            }

            personalForm(documentType, state.credit.document, state.touch)

            div("row") {
                div("col-lg col-md-12") {
                    label { +"Էլ․ փոստ" }
                    input(classes = "form-control") {
                        attrs {
                            val r = Regex("^([a-zA-Z0-9_.+-])+\\@(([a-zA-Z0-9-])+\\.)+([a-zA-Z0-9]{2,4})+$")
                            if((state.credit.email != null && !r.containsMatchIn(state.credit.email ?: "")) && state.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }
                        attrs["value"] = state.credit.email ?: ""
                        attrs.onChangeFunction = {
                            val email = getTargetValue(it)
                            setState {
                                credit.email = email
                            }
                        }
                    }
                }
                div("col-lg col-md-12") {
                    label { +"ՀԾՀ(սոց. քարտ)" }
                    input(classes = "form-control") {
                        attrs {
                            val r = Regex("^([0-9]{10})+$")
                            if((state.credit.hch == "" || !r.containsMatchIn(state.credit.hch)) && state.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }
                        attrs.value = state.credit.hch
                        attrs.onChangeFunction = {
                            val hch = getTargetValue(it)
                            setState {
                                state.credit.hch = hch
                            }
                        }
                    }
                }
            }
            div("row") {
                state.credit.phones.forEachIndexed { index, phone ->
                    div("col-lg col-md-12") {
                        label { + if(index == 0) "Հեռ․" else "" }
                        attrs.key = uuid()
                        div("input-group mb-2 mr-sm-2") {
                            if(state.credit.phones.size > 1) {
                                div("input-group-prepend") {
                                    div("input-group-text") {
                                        attrs {
                                            onClickFunction = {
                                                setState {
                                                    credit.phones.removeAt(index)
                                                }

                                            }
                                        }
                                        i("fa fa-minus") {}
                                    }
                                }
                            }
                            input(classes = "form-control phone") {
                                attrs {
                                    value = state.credit.phones[index]
                                    if(!state.credit.validatePhones() && state.touch) {
                                        jsStyle {
                                            border = "1px solid red"
                                        }
                                    }
                                    this["data-phone-index"] = index
                                    onChangeFunction = {}
                                    onBlurFunction = {
                                        val phone = getTargetValue(it)
                                        if(!state.credit.telRegex.containsMatchIn(phone)) {
                                            setState {
                                                credit.phones[index] = ""
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if(state.credit.phones.size < 4) {
                    div("col-md-1") {
                        label { }
                        button(classes = "form-control btn btn-dark") {
                            attrs {
                                onClickFunction = {
                                    setState {
                                        credit.phones.add("")
                                    }
                                }
                            }
                            i("fa fa-plus") {}
                        }
                    }
                }
            }

            div("row") {
                div("col-lg col-md-12") {
                    label { +"Լրացուցիչ տվյալներ" }
                    textArea(classes = "form-control") {
                        attrs.value = state.credit.other ?: ""
                        attrs.placeholder = "Լրացուցիչ տեղեկություններ Ձեր մասին"
                        attrs.onChangeFunction = {
                            val other = getTargetValue(it)
                            setState {
                                credit.other = other
                            }
                        }
                    }
                }
            }

            if(window.location.pathname != "/" && localStorage.get("jwt") != null) {
                div("row") {
                    div("col-lg") {
                        label { +"Կարգավիճակը" }
                        select("form-control") {

                            attrs.value = state.credit.status

                            attrs.onChangeFunction = {
                                val value = getTargetValue(it)
                                setState {
                                    state.credit.status = value
                                }
                            }
                            statusValues.forEach {
                                option {
                                    attrs.value = it
                                    +it
                                }
                            }
                        }
                    }
                }
            }

            div("row") {
                div("col-md-12") {
                    input(InputType.checkBox) {
                        attrs.id = "dataTrue"
                        attrs["checked"] = state.credit.dataRight
                        attrs.onChangeFunction = {
                            val isDataRight = getTargetValue(it)
                            setState {
                                credit.dataRight = isDataRight.toBoolean()
                            }
                        }
                    }
                    label {
                        attrs {
                            if(!state.credit.dataRight && state.touch) {
                                jsStyle {
                                    color = "red"
                                }
                            }
                        }
                        attrs["htmlFor"] = "dataTrue"
                        attrs.jsStyle {
                            cursor = "pointer"
                            paddingLeft = "10px"
                        }
                        +" Հաստատում եմ, որ սույն հայտի մեջ տվյալները ճիշտ են և արժանահավատ"
                    }
                }
                div("col-md-12") {
                    input(InputType.checkBox) {
                        attrs.id = "acra"
                        attrs["checked"] = state.credit.agreeWithAcra
                        attrs.onChangeFunction = {
                            val isAgreeWithAcra = getTargetValue(it)
                            setState {
                                credit.agreeWithAcra = isAgreeWithAcra.toBoolean()
                            }
                        }
                    }
                    label {
                        attrs {
                            if(!state.credit.agreeWithAcra && state.touch) {
                                jsStyle {
                                    color = "red"
                                }
                            }
                        }
                        attrs["htmlFor"] = "acra"
                        attrs.jsStyle {
                            cursor = "pointer"
                            paddingLeft = "10px"
                        }
                        +" Համաձայն եմ, որ վարկային կազմակերպության կողմից Վարկային բյուրո հարցում կատարվի իմ վարկային պատմության վերաբերյալ"
                    }
                }
            }
            div("row controllButtons") {
                div("col") {

                    if(window.location.pathname == "/" || localStorage.get("type") == "0") {
                        button {
                            attrs.onClickFunction = {
                                console.log(isProcessing)
                                if(!isProcessing) {
                                    isProcessing = true
                                    sendCreditRequest(state.credit)
                                    setState {
                                        state.time = Date()
                                    }
                                }
                            }
                            if(window.location.pathname != "/" && localStorage.get("jwt") != null) {
                                +"Պահպանել"
                            } else {
                                +"Ուղարկել"
                            }
                        }
                    }
                    if(window.location.pathname != "/" && localStorage.get("jwt") != null) {
                        button {
                            attrs {
                                onClickFunction = {
                                    window.print()
                                }
                                jsStyle {
                                    marginLeft = "10px"
                                }
                            }
                            +"Տպել"
                        }
                    }
                }
            }

        }
    }
}

fun RBuilder.creditForm(credit: Credit? = null, requestEvent: dynamic = null) = child(CreditForm::class) {
    attrs.credit = credit
    attrs.requestEvent = requestEvent
}